// extracted by mini-css-extract-plugin
export var billingAddress = "_qy-f";
export var contactInfo = "_qy-c";
export var customerInfoContainer = "_qy-b";
export var customerInfoRow = "_qy-9";
export var customerInfoSection = "_qy-a";
export var fullWidthDividerMobile = "_qy-g";
export var imageContainer = "_qy-1";
export var paymentMethod = "_qy-d";
export var priceText = "_qy-6";
export var priceTextMobile = "_qy-7";
export var product = "_qy-0";
export var productImage = "_qy-2";
export var productInfo = "_qy-4";
export var productTitle = "_qy-8";
export var quantityBadge = "_qy-3";
export var quantityText = "_qy-5";
export var shippingAddress = "_qy-e";